//
// session-service.js
//
// Copyright (c) 2014 by Curalate, Inc.
//

/* global angular: false, OpsSession: false */

((() => {
    /**
     * Exposes information about the current user's session
     */
    angular.module('curalate').service('SessionVarsService', () => {
        if (!OpsSession) {
            throw new Error('window.OpsSession is not defined.');
        }

        const session = {
            getCurrentUser() {
                return OpsSession.user;
            },
            getTimeZoneId() {
                return OpsSession.timeZoneId;
            },
            getTimeZoneFullName() {
                return OpsSession.timeZoneFullName;
            },
            getTimeZoneShortName() {
                return OpsSession.timeZoneShortName;
            },
        };

        return session;
    });
}))();
